var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sheet-block-with-share-menu"},[_vm._t("default"),(_vm.shareUrl)?_c('AppShareMenu',{staticClass:"sheet-block-with-share-menu__share-menu",attrs:{"share-url":_vm.shareUrl,"menu-alignment":_vm.shareMenuAlignment}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }